import React, { memo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { IProduct } from '../../../types/product'
import { getLabel } from '../../../validators'
import style from '../Styles/index.module.scss'
import { UnsavedChangesMark } from '../../UnsavedChangesMark'
import { Nav } from 'react-bootstrap'
import { getProductStatusValues } from '../../../utils/getProductStatusValues'
import { ProductStatus } from '../../../entity/Product'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { fetchProductSchemaAndConfig } from '../../../store/async-thunks/configurations/fetchProductSchemaAndConfig'
import { selectOneProduct } from '../../../store/selectors/productsSelectors'
import { selectUnsaved } from '../../../store/selectors/configSelectors'
import { productsActions } from '../../../store/slices/productsSlice'

interface IProductsDropdownItem {
    productId: string
    isPopover?: boolean
}

export const ProductsDropdownItem = memo(function ProductsDropdownItem({
    productId,
    isPopover,
}: IProductsDropdownItem) {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const history = useHistory()
    const product = useAppSelector(
        selectOneProduct(productId)
    ) as unknown as IProduct
    const { name, status, display_name: displayName, type } = product ?? {}
    const { statusStyle } = getProductStatusValues(status, type)
    const isProductRouted = location?.pathname?.includes(productId)
    const unsaved = useAppSelector(selectUnsaved)
    const productConfig = useAppSelector(selectOneProduct(productId))
    const productName = displayName || getLabel(name)
    const isProductActive =
        status === ProductStatus.ACTIVE || status === ProductStatus.IDLE

    const handleOnClick = (): void => {
        if (isProductActive) {
            dispatch(productsActions.setIsProductRouted({ isProductRouted: true }))
            history.push(`/${productId}`)
        }
        if (!productConfig && isProductActive) {
            dispatch(fetchProductSchemaAndConfig({ guid: productId }))
        }
    }

    return (
        <div
            className={`d-flex align-items-center justify-content-between w-100 ${
                isPopover && 'pb-1'
            }`}
        >
            <>
                <Nav.Link
                    onClick={handleOnClick}
                    className={`${!isProductActive && 'cursor-default'} dropdownLink ${
                        isProductRouted && isProductActive && 'active'
                    }`}
                    style={{ width: !isPopover ? '80%' : '85%' }}
                >
                    <span
                        className={`${!isProductActive && 'inactive'} dropdown-label ${
                            isPopover ? 'ms-4' : ''
                        }`}
                    >
                        <span className="p-relative">
                            <span
                                className={[
                                    style.dropdownProductLabel,
                                    !isProductActive && style.productInactive,
                                    'text-capitalize word-break',
                                ].join(' ')}
                            >
                                {productName}
                            </span>
                            {unsaved[productId] && (
                                <UnsavedChangesMark
                                    className={
                                        !isPopover
                                            ? style.editIndicator
                                            : style.editIndicatorPopover
                                    }
                                />
                            )}
                        </span>
                    </span>
                </Nav.Link>
                <div
                    className={`${
                        !isPopover && 'app-w-50'
                    } d-flex align-items-center p-relative pe-1`}
                    style={{ width: !isPopover ? '20%' : '15%' }}
                >
                    <span
                        style={{ width: '6px', height: '6px' }}
                        className={`${statusStyle} ${style.workStatusIndicator}`}
                    />
                </div>
            </>
        </div>
    )
})
